class ProductDividerHeader extends HTMLElement {
  constructor() {
    super();
  }
}
class ProductDividerContent extends HTMLElement {
  constructor() {
    super();
  }
}

class ProductDivider extends HTMLElement {
  constructor() {
    super();
    this.querySelector("product-divider-header").addEventListener("click", () => this.toggleContent());
  }

  toggleContent = () => {
    this.querySelector("product-divider-content").classList.toggle("hidden");
  };
}

class ProductMediaOverlay extends HTMLElement {
  constructor(){
    super();
  }
}

class ProductMediaShowroom extends HTMLElement {
  constructor(){
    super();
  }
}

class ProductMediaFeatured extends HTMLElement {
  constructor(){
    super();
  }
}

class ProductMediaZoom extends HTMLElement {
  constructor(){
    super();
  }
}

class ProductMedia extends HTMLElement {
  constructor(){
    super();

    this.showroom = this.querySelector('product-media-showroom');
    this.overlay = this.querySelector('product-media-overlay');
    this.featured = this.querySelector('product-media-featured');
    this.zoom = this.querySelector('product-media-zoom');

    // Showroom
    this.overlay.addEventListener('click', () => {
      this.overlay.classList.toggle('hidden', true);
      this.overlay.classList.toggle('flex', false);
    });

    this.featured.addEventListener("click", event => {
      const img = event.currentTarget.querySelector('img');
      this.overlay.classList.toggle("hidden", false);
      this.overlay.classList.toggle('flex', true);
      this.showroom.innerHTML = "";
      var clone = img.cloneNode(true);
      clone.classList = "rounded max-w-[90vw] max-h-[90vh]";
      this.showroom.appendChild(clone);
    });

    // Zoom
    document.addEventListener('mousemove', event => {
      this.zoom.style.transform = `translateX(${ event.clientX - 50 }px)`;
      this.zoom.style.transform += `translateY(${ event.clientY - 490 }px)`;      
    }, false);

    this.featured.addEventListener("mouseenter", event => {
      this.zoom.classList.toggle("hidden", false);
      this.zoom.classList.toggle("flex", true);
    });
    
    this.featured.addEventListener("mouseleave", event => {
      this.zoom.classList.toggle("hidden", true);
      this.zoom.classList.toggle("flex", false);
    });

    this.featured.addEventListener("mousemove", e => {

      e.preventDefault();

      // Get pos in %
      const x = e.offsetX / e.currentTarget.offsetWidth * 100
      const y = e.offsetY / e.currentTarget.offsetHeight * 100

      // Apply to BG & slight correcting - Might need improvements
      this.zoom.style.backgroundPosition = `${ x + 5 }% ${ y <= 50 ? y -5 : y + 5 }%`;
    });
  }
}

customElements.define("product-divider-header", ProductDividerHeader);
customElements.define("product-divider-content", ProductDividerContent);
customElements.define("product-divider", ProductDivider);
customElements.define("product-media-overlay", ProductMediaOverlay);
customElements.define("product-media-showroom", ProductMediaShowroom);
customElements.define("product-media-featured", ProductMediaFeatured);
customElements.define("product-media-zoom", ProductMediaZoom);
customElements.define("product-media", ProductMedia);
